import ProfileImg from '../../../assets/images/profile.png';
import React from 'react';
import {BiMenuAltLeft, BiSearch} from 'react-icons/bi';
import {BsFillBellFill} from 'react-icons/bs';
import Input from '../forms/Input';
const Navbar = ({toggleSidebar, firstName}) => {
  const auth = JSON.parse(window.sessionStorage.getItem('auth'));
  console.log(auth, "navbarAuth")
   const roles = JSON.parse(sessionStorage.getItem("#roles") || "{}");
   const textColor = roles === "student"? "text-primary" :roles === "teacher"?"text-blueColor"?roles === "guest":"text-green-400":""
   const bgColor = roles === "student"? "bg-primary" :roles === "teacher"?"bg-blueColor"?roles === "guest":"bg-green-400":""

  return (
    <div className='flex justify-between items-center py-4 lg:px-6 px-2 bg-white gap-4'>
      <div className='flex items-center gap-6 bg-white'>
        <button onClick={toggleSidebar} className='focus:outline-none'>
          <BiMenuAltLeft size={28} color='#616161' />
        </button>
        <h2 className='md:text-lg text-[#00000] font-ManropeBold leading-[20px] '>{roles==="student"?"Student Dashboard": roles === "teacher" ? "Teacher Dashboard":"Guest Dashboard"}</h2>
      </div>

      <div className='md:w-[346px] md:flex hidden h-10  flex-row items-center px-4 bg-lightYellow border-none rounded-md border'>
              <input
                type='text'
                placeholder='Search'
                className='w-full h-full bg-lightYellow outline-none focus:outline-none'
                // onChange={(e) => setQuery(e.target.value)}
              />
              <div className='w-[10%]'>
                <BiSearch size={20} className='text-gray-400' />
              </div>
            </div>


      <div className='flex items-center space-x-4 '>
        <div className='flex flex-row justify-center items-center lg:w-10 lg:h-10 h-8 w-8 bg-[#E1E7FF] rounded-full relative'>
          <BsFillBellFill className={`${textColor}`} size={18} />
          <div className={`text-white ${bgColor} rounded-full flex flex-row justify-center items-center w-4 h-4 absolute right-0 top-0`}>
            <p className='text-xs'>13</p>
          </div>
        </div>


        <div className='lg:w-11 lg:h-11 w-8 h-8 flex gap-2'>
          <img
            src={ProfileImg}
            alt='User'
            className='w-full h-full rounded-full object-cover'
          />
          {firstName}
       
        </div>
        <div>
          <h2 className='md:text-[16px] font-ManropeSemibold text-[#0B7077]'>{auth.name}</h2>
          <p className='text-[#8F8F8F] text-[11px] leading-[16px] capitalize'>{roles}</p>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
